import React from 'react';
export function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="inicio" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" aria-label="Sección principal" data-id="element-39">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/no2x6Xyss8b8YKBa71vjS3/ChatGPT_Image_28_feb_2026,_05_15_48_p.m..png')`
    }} aria-hidden="true" data-id="element-40" />
      {/* Dark navy overlay */}
      <div className="absolute inset-0" style={{
      backgroundColor: 'rgba(13, 27, 46, 0.82)'
    }} aria-hidden="true" data-id="element-41" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 flex flex-col items-center text-center" data-id="element-42">
        {/* Top Badge */}
        <div className="mb-6" data-id="element-43">
          <span className="inline-block bg-gold text-navy-deep text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full" style={{
          letterSpacing: '0.12em'
        }} data-id="element-44">
            EL RECURSO #1 PARA DOCENTES DE CATEQUESIS EN ARGENTINA 🇦🇷
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-45">
          Mega Pack Catequesis Lista:
          <br data-id="element-46" />
          <span className="text-gold" data-id="element-47">Herramientas Completas</span>
        </h1>

        {/* Product Mockup */}
        <div className="my-4 w-full max-w-xs mx-auto" data-id="element-48">
          <img src="https://cdn.magicpatterns.com/uploads/duRKPLUByYSy6rXFPwEp6j/ChatGPT_Image_27_feb_2026,_02_26_12_p.m.-Photoroom.png" alt="Mega Pack Catequesis Lista - 12 tomos PDF completos" className="w-full h-auto drop-shadow-2xl" style={{
          maxHeight: '260px',
          objectFit: 'contain'
        }} data-id="element-49" />
        </div>

        {/* Subtitle */}
        <p className="text-white text-sm sm:text-base max-w-xl mx-auto mb-8 leading-relaxed opacity-90" data-id="element-50">
          Planificaciones, actividades y proyectos listos para usar en el aula o
          en catequesis parroquial.{' '}
          <strong className="text-gold" data-id="element-51">
            Transformá tus clases de religión desde mañana.
          </strong>
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-52">
          <button onClick={() => scrollTo('precios')} className="bg-gold text-navy-deep font-bold text-lg px-10 py-4 rounded-full hover:bg-gold-light transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-53">
            Adquirir Ahora
          </button>
          <button onClick={() => scrollTo('incluye')} className="border-2 border-white text-white font-semibold text-lg px-10 py-4 rounded-full hover:bg-white hover:text-navy-deep transition-all duration-200" data-id="element-54">
            Más Información
          </button>
        </div>

        {/* Trust indicators */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-white opacity-75 text-sm" data-id="element-55">
          <span data-id="element-56">✓ Acceso inmediato</span>
          <span data-id="element-57">✓ Garantía 7 días</span>
          <span data-id="element-58">✓ Pago seguro 🔒</span>
        </div>
      </div>
    </section>;
}